// Shopify Forms renders inside a shadow root and only exposes some styles as
// CSS variables (set in custom.css). This adds the rest to the form's shadow
// root. Its internal class names are generated, so match on attributes or
// class-name prefixes only.
(() => {
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(`
    h2[class*="_textHeading_"],
    [class*="_formBannerContainer_"] [class*="_formBannerHeading_"] {
      font: var(--forms-heading-font);
      text-transform: var(--font-heading-text-transform);
      letter-spacing: var(--font-heading-base-letter-spacing);
      line-height: var(--line-height-heading);
      margin: 0 0 var(--spacing-3);
    }

    [class*="_textBody_"],
    p[class*="_textBody_"],
    span[class*="_textBody_"] {
      line-height: 1.5;
    }

    [class*="_formBannerContainer_"] [class*="_textBody_"] {
      font-size: var(--font-size-body-200);
    }

    /* Forms marks required fields only for screen readers, via aria-required
       on inputs and a "-required" description on checkbox fieldsets. The
       asterisk is hidden from screen readers so it isn't announced twice. */
    [class*="_formFieldContainer_"]:has([aria-required="true"]) [class*="_formInputFieldLabel_"]::after,
    fieldset[aria-describedby*="-required"] > legend::after {
      content: " *";
      content: " *" / "";
    }

    [class*="_selectToggle_"] {
      max-height: none;
      height: 100%;
    }

    [class*="_arrowDownIcon_"] path {
      fill: currentColor;
    }

    button[type="submit"] {
      box-sizing: border-box;
      align-items: center;
      min-height: var(--height-input);
      padding-block: 0;
      font-family: var(--font-button);
      font-weight: var(--font-weight-button);
      font-style: var(--font-style-button);
      font-size: var(--font-size-button);
      letter-spacing: var(--button-letter-spacing);
      line-height: var(--line-height-button);
      text-transform: var(--font-button-text-transform);
    }

    /* Below 490px Forms centres the form at its content width instead of
       filling the column. */
    [class*="_container_"] {
      justify-content: stretch;
    }
  `);

  const style = (host) => {
    const root = host.shadowRoot;
    if (!root || root.adoptedStyleSheets.includes(sheet)) return;
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
  };

  const styleAll = () => {
    document.querySelectorAll(".apps shopify-forms-embed").forEach(style);
  };

  customElements.whenDefined("shopify-forms-embed").then(() => {
    styleAll();
    new MutationObserver(styleAll).observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();
